import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import { Formik } from "formik";
import React, { useState } from "react";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import editIocn from "../../../../../assets/inventory/edit-icon.svg";
import deleteIcon from "../../../../../assets/inventory/delete-icon.svg";
import CloseIcon from "../../../../../assets/icon/chatClose.svg";
import exports from "assets/icon/export-icon.svg";
import reloadIcon from "assets/icon/reload-icon.svg";
import refreshIcon from "../../../../../assets/icon/refresh-purple.svg";

import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Offcanvas,
  OffcanvasBody,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import DrugName from "components/DrugName";
// import DragDrop from "components/DragDrop";
// import Drawer from "components/Drawer";
// import OrderEditDetails from "../OrderEditDetails";

const OnOrderQueue = () => {
  const navigate = useNavigate();
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [rSelected, setRSelected] = useState("off");
 const [tableData, setTableData] = useState(rowData);
      const [dataRow, setDataRow] = useState([]);

  function handleClick() {
    // window.location.reload();
  }

  const handleRowClick = (row) => {
    navigate(`/inventory-purchase-order/on-order-queue-details/${row.id}`, { state: row });
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };
  const renderExport = () => {
    return (
      <div>
        <img src={exports} alt="export-icon" />
      </div>
    );
  };

  const columnData = [
    {
      id: "1",
      dataField: "export",
      text: "Export",
      show: true,
      width: 100,
      // sort: true,
      cellRenderer: (rowData) => renderExport(rowData),
    },
    {
      id: "2",
      dataField: "drugStatus",
      text: "Drug Status",
      show: true,
      width: 125,
      sort: true,
    },
    {
      id: "3",
      dataField: "orderId",
      text: "Order Id",
      show: true,
      width: 150,
      sort: true,
    },

    {
      id: "4",
      dataField: "submissonDate",
      text: "Submission Date",
      show: true,
      width: 160,
      sort: true,
    },
    {
      id: "5",
      dataField: "mfgValue",
      text: "Mfg. Name",
      show: true,
      width: 150,
      sort: true,
      // cellRenderer: (rowData) => (
      //   <a href="/on-order-queue-details" style={{ color: "#212529" }}>
      //     {rowData.mfgValue}
      //   </a>
      // ),
    },
    {
      id: "6",
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      width: 150,
      sort: true,
      cellRenderer: (rowData) => DrugName(rowData),
    },
    {
      id: "7",
      dataField: "itemOrdered",
      text: "Items Ordered",
      show: true,
      width: 150,
      sort: true,
    },
  ];

  const rowData = [
    {
      id: 1122,
      drugStatus: "Acknowledged",
      orderId: "1023850",
      submissonDate: "01/08/2025",
      mfgValue: "Mckesson",
      drugname: "Amlodipine 10 MG Cetirizine 5MG ch...",
      itemOrdered: "12",
    },
    {
      id: 2244,
      drugStatus: "Submitted",
      orderId: "1023850",
      submissonDate: "02/09/2025",
      mfgValue: "Ando",
      drugname: "Hydrochlorothiazide",
      itemOrdered: "1",
    },
    {
      id: 3344,
      drugStatus: "Acknowledged",
      orderId: "1023850",
      submissonDate: "03/10/2025",
      mfgValue: "Cardinal",
      drugname: "Insulin Glargine kwikpen 100U/ML",
      itemOrdered: "12",
    },
  ];

  //   const handleRefresh = () => {
  //     window.location.reload(); // Refreshes the page

  //   };

  const [data, setData] = useState(rowData);

  function handleClick() {
    // window.location.reload();
    setData([...rowData]);
  }

  const handleRefresh = () => {
    setRefreshBtn(true);
    setTimeout(() => {
      setRefreshBtn(false);
    }, 2000);
  };

  return (
    <div className="table-card scroll-table position-relative border-0 pt-1 rounded bg-white">
      {refreshBtn && (
        <div className="refresh-bgv">
          <img className="rotate-img" src={refreshIcon} width={40} />
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Drug Name"}
              data={dataRow}
              setFilterData={setTableData}
            />
          </div>
          <div>
            <Dropdown isOpen={undefined} toggle={undefined}>
              <DropdownToggle className="clmn">
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                </span>
              </DropdownToggle>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className="d-flex">
          <Button color="primary" onClick={handleRefresh}>
            <img src={reloadIcon} alt="Refreshing..." />
            Refresh
          </Button>
        </div>
      </div>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="purchase-onOrders"
          columns={columnData}
          data={rowData}
          enablerowRouting={true}
          handleRowClick={handleRowClick}
          redRow={[0]}
        />
      </div>
      <div>
        {/* {isRefreshing && <img src={exports} alt="Refreshing..." />} */}
      </div>
    </div>
  );
};

export default OnOrderQueue;
